function SendOutline({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '21'} height=${(dimensions * 6) / 7 || '18'}  viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M2.01 3.03L9.52 6.25L2 5.25L2.01 3.03ZM9.51 11.75L2 14.97V12.75L9.51 11.75ZM0.00999999 0L0 7L15 9L0 11L0.00999999 18L21 9L0.00999999 0Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default SendOutline;
